import {
	Component,
	OnInit,
	Input,
	SimpleChanges,
	ChangeDetectorRef,
} from "@angular/core";
import { BasePopup } from "../../../../core/views/base-popup";

@Component({
	selector: "app-instruction-popup",
	templateUrl: "./instruction-popup.html",
	styleUrls: ["./instruction-popup.css"],
})
export class InstructionPopupDirective extends BasePopup {
	@Input() disabled: boolean;
	public header: string;
	public bodyText: string;
	public buttonLabel: string;
	public havePopup: boolean;
	public bHidePopup: boolean;

	public initialize(popupdata: any): void {
		console.log("InstructionPopupDirective initialize ", popupdata);
		if (popupdata == null) {
			this.havePopup = false;
			this.bHidePopup = false;
			return;
		}
		this.bHidePopup = true;
		this.header = popupdata.title ? popupdata.title : "";
		this.bodyText = popupdata.bodyText ? popupdata.bodyText : "";
		this.buttonLabel = popupdata.buttonLabel ? popupdata.buttonLabel : "";
		console.log("InstructionPopupDirective  data get ");
	}
	public popupClosed() {
		this.bHidePopup = false;
		this.popupClose.emit("closed");
	}
	public popupOpen() {
		this.bHidePopup = true;
		this.popupOpened.emit("opened");
	}
}
